<template>
  <div>
    <el-dialog :visible.sync="sub.maskShow" :modal="false">
      <subAddressAdd
        :visible.sync="sub.maskShow"
        :props="formData"
        :isEdit="sub.isEdit"
        :key="Math.random()"
        @on-change="getList()"
        @on-cancel="handleCancel"
        @initAddress="handleCancel"
        style="width: 100%; margin-top: 30vh; background-color: #00bcd412"
      />
    </el-dialog>
    <el-card class="sub-box" bg="white">
      <div class="flex-center">
        {{ $t("subAddress.subAddress1" || '请输入收件人信息') }}
      </div>
      <div style="display: flex; margin: 10px 0">
        <el-input v-model="queryCondition" :placeholder="$t('subAddress.subAddress13' || '请输入部分详细地址进行搜索')" />
        <el-button type="primary" @click="getList()" style="padding: 8px 20px;">{{ $t("subAddress.subAddress2" || '搜索') }}</el-button>
      </div>
      <el-form justify="end" class="set-form" space="10px 0 0px 5px" :label-width="'7.5rem'">
        <div v-if="sub.addressList.length > 0">
          <div class="el-text">
            <b>{{ $t("subAddress.subAddress3" || '选择地址') }}</b>
          </div>
          <div class="address-box-wrap">
            <el-card class="address-box" v-for="(item, index) in sub.addressList" :key="index" style="background-color: #9e9e9e3d">
              <div>
                <el-form-item :label="$t('subAddress.subAddress4' || '姓名')">
                  <div class="text-row-2" style="margin-top: 0; width: 80%">{{ item.receiverName }}</div>
                </el-form-item>
                <el-form-item :label="$t('subAddress.subAddress9' || '电话')">
                  <div class="text-row-2" style="margin-top: 0; width: 220px">{{ item.receiverPhone }}</div>
                </el-form-item>
                <el-form-item :label="$t('subAddress.subAddress5' || '地址')">
                  <div class="text-row-2" style="margin-top: 0">
                    {{ item.provenceName }}
                    {{ item.areaName }}
                    {{ item.cityName }}
                  </div>
                </el-form-item>
                <el-form-item :label="$t('subAddress.subAddress6' || '邮政编码')">
                  <div class="text-row-2" style="margin-top: 0; width: 80%">{{ item.postcode }}</div>
                </el-form-item>
                <el-form-item :label="$t('subAddress.subAddress16' || '详细地址')">
                  <div class="text-row-2" style="margin-top: 0">{{ item.addressInfo }}</div>
                </el-form-item>
                <el-form-item :label="$t('subAddress.subAddress8' || '备注')">
                  <div class="text-row-2" style="margin-top: 0">{{ item.notes }}</div>
                </el-form-item>
                <div class="right-button">
                  <el-button type="primary" size="mini" @click="addressSelect(index, item)">{{ $t("subAddress.subAddress11" || '选择') }}</el-button>
                  <div style="height: 5px; padding: 5px"></div>
                  <el-button type="primary" size="mini" @click="editSelect(index, item)">{{ $t("subAddress.subAddress12" || '编辑') }}</el-button>
                </div>
              </div>
            </el-card>
          </div>
          <div class="flex-center" v-if="page.total > 0">
            <el-pagination
              background
              layout="prev,pager,next,jumper"
              :page-size="2"
              :current-page="page.pageNum"
              @next-click="getList()"
              @prev-click="getList()"
              @current-change="changePage"
              :total="page.total"
            />
          </div>
        </div>
        <template v-if="sub.addressList.length < 10">
          <div class="el-text">
            <b>{{ $t("subAddress.subAddress14" || '新增地址') }}</b>
          </div>
          <subAddressAdd style="width: 100%" @on-cancel="handleCancel(1)" @initAddress="handleCancel()" @on-change="addressChange" />
        </template>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { PageList, WsMsg } from "@/class";
import subAddressAdd from "./subAddressAdd.vue";
import { FormVerify } from "@/class";

export default {
  name: "SubAddress",
  components: {
    subAddressAdd,
  },
  data() {
    return {
      queryCondition: "",
      pagelist: new PageList(),
      sub: {
        isEdit: false,
        maskShow: false,
        addressShow: false,
        logistics: false,
        addressList: [],
        addressValue: [],
        addressSelect: undefined,
        addressOption: [],
        address: undefined,
        props: {
          label: "label",
          value: "label",
          expandTrigger: "hover",
        },
      },
      formData: {
        receiverName: undefined,
        receiverPhone: undefined,
        provenceName: undefined,
        provence: undefined,
        cityName: undefined,
        city: undefined,
        areaName: undefined,
        area: undefined,
        addressInfo: undefined,
        defaultAddress: undefined,
      },
    };
  },
  computed: {
    page() {
      return this.pagelist.page;
    },
  },
  watch: {
    formData: {
      handler(val, old) {
        if (val) {
          this.sub.addressValue = [val.country, val.provence, val.city];
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getList();
    // getAreaJp({}).then((res) => {
    //   this.sub.addressOption = res.data;
    // });
  },
  methods: {
    //遍历目标对象，复制目标的所有key及值
    clonKeys(obj, target) {
      for (let key in target) {
        obj[key] = target[key];
      }
    },
    onCancel() {
      this.$emit("onCancel", false);
      this.$emit("update:show", false);
    },
    handleClick() {
      console.log(this.queryCondition);
    },
    getAddressChange(event) {
      try {
        let node = this.$refs.cascader.getCheckedNodes();
        let { pathLabels } = node[0];
        console.log("node", node[0]);
        this.formData.countryName = pathLabels[0];
        this.formData.country = event[0];
        this.formData.provinceName = pathLabels[1];
        this.formData.provence = event[1];
        this.formData.cityName = pathLabels[2];
        this.formData.city = event[2];
        this.formData.areaName = pathLabels[3];
        this.formData.area = event[3];
      } catch (err) {}
      console.log("formData", this.formData);
    },
    editSelect(index, item) {
      console.log('index===',index)
      console.log('item===',item);
      this.sub.maskShow = true;
      this.sub.isEdit = true;
      this.clonKeys(this.formData, item);
    },
    onDel(index, item) {
      let data = {
        ...item,
        delFlag: 1,
      };
      postAddressEdit(data).then((res) => {
        if (res.code === 200) {
          new WsMsg(this.$t("wslang328"));
          this.getList();
        }
      });
    },
    addressSelect(index, item) {
      this.sub.addressShow = false;
      this.clonKeys(this.formData, item);
      this.sub.address = (item?.provence || "") + (item?.city || "") + (item?.area || "") + (item?.addressInfo || "");
      this.formData.address = this.sub.address;
      this.$emit("onChange", this.formData);
      this.$emit("update:show", false);
    },
    async addressChange(event) {
      await this.getList()
      console.log(this.sub.addressList[0],123123);
      this.$emit("onChange", this.sub.addressList[0]);
      this.$emit("update:show", false);
    },
    handleCancel(type) {
      // 关闭当前组件的对话框
      if (type == 1) {
        // 向父组件发出关闭事件
        this.$emit("onCancel", false);
        this.$emit("update:show", false);
      }
      this.sub.maskShow = false;
    },
    initAddress(event) {
      this.handleCancel();
    },
    verifyData(item) {
      let v = new FormVerify();
      const rule = {
        receiverName: { keys: ["isEmpty"], msg: [this.$t("wslang285")] },
        receiverPhone: {
          keys: ["isEmpty"],
          msg: [this.$t("wslang272")],
        },
        provinceName: { keys: ["isEmpty"], msg: [this.$t("wslang299")] },
        addressInfo: { keys: ["isEmpty"], msg: [this.$t("wslang280")] },
      };
      v.rules(rule, item);
    },
    onSave(item) {
      this.verifyData(item);
      let data = {
        ...this.formData,
        ...item,
        type: 0,
      };
      postAddressEdit(data).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: this.$t("wslang449"),
            type: "success",
          });
        }
      });
    },
    changePage(val = 1) {
      this.pagelist.page.pageNum = val;
      this.getList();
    },
    async getList() {
      let data = {
        type: 0,
        pageNum: this.page.pageNum,
        pageSize: 2,
        receiverName: this.queryCondition
      };
      let url = "cms/configAddressInfo/list";
      const { data: res } = await this.$http.get(url, { params: data });
      console.log(res, "asdaa");

      this.sub.addressList = res.data.list;
      this.sub.addressList.forEach((item) => {
        this.sub.addressValue = [item.country, item.provence, item.city];
      });
      this.page.total = res.data.total || 0;
    },
  },
};
</script>

<style scoped lang="less">
.address-box-wrap {
  ::v-deep .el-card__body .el-form-item {
    margin-bottom: 0 !important;
    .el-form-item__label {
      line-height: 20px !important;
    }
    .el-form-item__content {
      line-height: 20px;
    }
  }
}
.el-button {
  min-height: 32px;
}
.sub-box {
  width: 928px;
  height: auto;
  padding: 0px;
  border: 0;
}
.set-form {
  ::v-deep .text-right {
    min-width: auto;
  }
}
.address-box {
  position: relative;
  background: var(--home-background);
  overflow: hidden;
  width: 49%;
  margin-bottom: 16px;
  border-radius: 10px;
}
.address-box-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.address-box ::v-deep .el-form-item {
  margin: 0;
}
.right-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
.el-text {
  font-size: 14px;
  color: #606266;
}
::v-deep .el-dialog__header{
  padding: 0;
}
</style>
